import type { StaticImageData } from 'next/image';
import Image from 'next/image';

import type { SimpleSideMenuItem } from './SideMenu';

interface FeatureItemProps {
  feature: SimpleSideMenuItem<StaticImageData>;
}

export default function FeatureItem({ feature }: FeatureItemProps) {
  return (
    <div
      id={feature.id}
      // The `feature` class name is used to query feature elements in the scroll handler
      className="feature flex flex-col space-y-5"
    >
      <div className="pt-1 text-lg font-medium text-primary-200">
        {feature.description}
      </div>
      <div className="leading-6">{feature.content}</div>
      <Image
        src={feature.media}
        alt={feature.title}
        priority
        className="object-cover"
        placeholder="blur"
        blurDataURL="rgbDataURL(255, 255, 255)"
      />
    </div>
  );
}
